import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ChatWorkspace from '../components/Chat/ChatWorkspace';

const ChatPage: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const productId = params.get('productId') || undefined;
  const orderId = params.get('orderId') ? Number(params.get('orderId')) : null;
  const tab = params.get('tab') === 'buyers' ? 'buyers' : 'analysts';

  return (
    <div className="container-fluid py-3" style={{ height: 'calc(100vh - 70px)' }}>
      <h5 className="mb-3">Chat</h5>
      <div style={{ height: 'calc(100% - 40px)' }}>
        <ChatWorkspace
          tab={tab}
          initialProductId={productId}
          initialOrderId={Number.isInteger(orderId) ? orderId : null}
          onTabChange={(next) => {
            const nextParams = new URLSearchParams(params);
            nextParams.set('tab', next);
            setParams(nextParams, { replace: true });
          }}
          onSelectOrder={(id) => {
            const nextParams = new URLSearchParams(params);
            nextParams.set('tab', 'buyers');
            nextParams.set('orderId', String(id));
            setParams(nextParams, { replace: true });
          }}
        />
      </div>
    </div>
  );
};

export default ChatPage;
